const donorboxScript = document.createElement('script');
donorboxScript.src = 'https://donorbox.org/widget.js'; // URL for the third-party library being loaded.
donorboxScript.id = 'donorbox'; // e.g., googleMaps or stripe
// extra attributes
donorboxScript.paypalExpress = "false";

export default donorboxScript;